module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/ivano-frankivsk-kyiv-89bf875cedd17197f3e85eaa30befe43.png";